// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.mainBox {
    display: grid;
    padding: 40px;
    grid-template-columns: 1fr 240px;
}

.check_BoxArea {
    display: grid;
    height: 40vh;
    margin-left: 50px;
}

.modal_Box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    background-color: #ffffff;
    box-shadow: 24px;
    padding: 24px;
}

.modal_Form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* margin: 5px; */
}

.modal_Heading {
    font-family: sans-serif;
    font-weight: bold;
    font-size: 25px;
    margin: 20px,
}

.modal_text {
    font-family: sans-serif;
    color: red;
    font-size: 15px;
    margin-right: 303px;
    margin-bottom: 10px;
}

.img {
    width: 45px;
    height: 45px;
    position: absolute;
}

.downArrowImg {
    background: none;
    background-color: white;
    width: 40px;
    height: 40px;
    position: absolute;
}

.listItem {
    margin-left: 1rem;
    margin-top: 0.5rem
}

.sugesstionModal {
    border: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    background-color: #ffffff;
    box-shadow: 24px;
    padding: 24px;
}

.suggestionModalHeading {
    margin-top: 8px;
    margin-left: 10px
}

.suggestionText {
    color: "black";
    font-weight: "bold";
    cursor: pointer;
}


.evaluateBtn {
    color: #1976d2;
    border-radius: 15px;
    margin-bottom: 10px;

}`, "",{"version":3,"sources":["webpack://./src/Components/ChatArea/ChatArea.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,aAAa;IACb,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;;AAEvB","sourcesContent":["/* styles.css */\n.mainBox {\n    display: grid;\n    padding: 40px;\n    grid-template-columns: 1fr 240px;\n}\n\n.check_BoxArea {\n    display: grid;\n    height: 40vh;\n    margin-left: 50px;\n}\n\n.modal_Box {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 800px;\n    background-color: #ffffff;\n    box-shadow: 24px;\n    padding: 24px;\n}\n\n.modal_Form {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* margin: 5px; */\n}\n\n.modal_Heading {\n    font-family: sans-serif;\n    font-weight: bold;\n    font-size: 25px;\n    margin: 20px,\n}\n\n.modal_text {\n    font-family: sans-serif;\n    color: red;\n    font-size: 15px;\n    margin-right: 303px;\n    margin-bottom: 10px;\n}\n\n.img {\n    width: 45px;\n    height: 45px;\n    position: absolute;\n}\n\n.downArrowImg {\n    background: none;\n    background-color: white;\n    width: 40px;\n    height: 40px;\n    position: absolute;\n}\n\n.listItem {\n    margin-left: 1rem;\n    margin-top: 0.5rem\n}\n\n.sugesstionModal {\n    border: none;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 600px;\n    background-color: #ffffff;\n    box-shadow: 24px;\n    padding: 24px;\n}\n\n.suggestionModalHeading {\n    margin-top: 8px;\n    margin-left: 10px\n}\n\n.suggestionText {\n    color: \"black\";\n    font-weight: \"bold\";\n    cursor: pointer;\n}\n\n\n.evaluateBtn {\n    color: #1976d2;\n    border-radius: 15px;\n    margin-bottom: 10px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
